const filterOptionsJson = require('./filter_options.json'); // Include in bundle. No need to use ajax
const specialCodesJson = require('./special_codes.json');
import "./query_ui.html";

export default function queryUi($http) {
    "ngInject";

    return {
        restrict: 'EA',
        templateUrl: "/app/query/ocom_query/query_ui.html",
        scope: {
            query: "=",
            modelName: "@",
            apply: "&?"
        },
        controller: function ($scope) {
            $http.get("/query/meta_data/?modelName=" + $scope.modelName).then(function (data) {
                $scope.metaData = data.data;
            });
            $scope.filterOption = filterOptionsJson;
            $scope.specialOptions = specialCodesJson;

            $http.get("/query/models").then(function (data) {
                $scope.modelList = data.data;
            });


        }

    };
}
